import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

const REQUEST_TYPE: keyof typeof apiConfig = 'get home recent searches';
export type RecentSearchItems = components["schemas"]["SearchItem"][];

async function getRecentSearches(): Promise<RecentSearchItems> {
    return await http.get(REQUEST_TYPE);
}

export function useHomeRecentSearches() {
    return useData([], getRecentSearches);
}